import LinearProgress from '@material-ui/core/LinearProgress';
import styled from 'styled-components';

export const StyledLinearProgress = styled(LinearProgress)<{value: number}>`
    & .MuiLinearProgress-barColorPrimary {
        background-color: ${props => {
            const { value } = props;

            if (value > 80) {
                return '#28a745';
            }
            else if (value > 40) {
                return '#ffa500';
            }
            else {
                return '#ea0000';
            }
        }};
    }

    background-color: ${props => {
        const { value } = props;

        if (value > 80) {
            return '#9fd4a0';
        }
        else if (value > 40) {
            return '#ffd191';
        }
        else {
            return '#ffbca8';
        }
    }};
`;
